<template>
    <div class="search-dropdown" v-show="show">
        <template v-if="searchResult && searchResult.totalHits > 0">
            <a :href="`${$scope.URL}search?query=${searchQuery}`" target="_self"
               class="btn btn-light center-block hidden-xs-down">
                Ver todos os resultados ({{ searchResult.totalHits }})
            </a>
            <a :href="`${$scope.URL}search?query=${searchQuery}`" target="_self"
               class="btn btn-light hidden-xs-up">
                Ver todos ({{ searchResult.totalHits }})
            </a>
            <div class="search-suggestions" @mouseleave="selectedIndex = -1">
                <div class="search-suggestion"
                     :class="{ 'selected': selectedIndex === index }"
                     v-for="(hit, index) in searchResult.hits"
                     :key="hit.id"
                     @click="productClick(hit)"
                     @mouseenter="selectedIndex = index">
                    <div class="product-list-item d-flex flex-spaced-fixed">
                        <div class="search-result-thumb flex-child-fixed">
                            <img :src="`${hit.img_cover}?auto=format&lossless=1&w=85&h=105&fit=crop`"
                                 :alt="hit.name" width="85" height="105"/>
                        </div>

                        <div>
                            <div class="product-list-item-title">{{ hit.name }}</div>

                            <div class="product-list-item-price" v-if="hit.in_stock">
                                <template v-if="$scope.IS_WHOLESALER || $scope.IS_SALES_REP">
                                    R$ {{ hit.price_ws }}
                                </template>
                                <template v-else-if="$scope.IS_REGULAR_CUSTOMER">
                                    <span v-if="hit.price_old > 0 && hit.price_old > hit.price" class="text-accent">De <del>R${{
                                            hit.price_old
                                        }}</del> por R${{
                                            hit.price
                                        }}</span>
                                    <span v-else>
                                        <span
                                            v-if="hit.price_min > 0 && hit.price_max > 0 && hit.price_min < hit.price_max">A partir de </span>
                                        R${{ hit.price }}
                                    </span>
                                </template>
                            </div>
                            <div v-else>Indisponível</div>

                            <div class="search-result-breadcrumb">Em:&nbsp;
                                <ul class="cr-breadcrumb mx-0 my-0">
                                    <li v-if="hit.super_type.name"><a :href="`${$scope.URL}${hit.super_type.url}/`"
                                                                      target="_self">{{ hit.super_type.name }}</a>&nbsp;
                                    </li>
                                    <li v-if="hit.type.name"><a :href="`${$scope.URL}${hit.type.url}/`" target="_self">{{
                                            hit.type.name
                                        }}</a>&nbsp;
                                    </li>
                                </ul>
                            </div>

                            <div
                                v-if="hit.categories && hit.categories.filter(c => c.parent_id === 5 && !c.hidden).length > 0">
                                Categorias:
                                <span
                                    v-for="(category, index) in hit.categories.filter(c => c.parent_id === 5 && !c.hidden)">
                                    <span v-if="index > 0">,&nbsp;</span><a
                                    :href="`${$scope.URL}${hit.type.url }/${category.url}/`"
                                    target="_self">{{ category.name }}</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div
            v-else-if="searchResult && searchResult.totalHits === 0"
            class="px">
            <h4>Ops! Não encontramos resultados para o filtro utilizado</h4>
            <div class="categories-suggestion">
                Ver tudo em: <a class="text-accent" :href="`${$scope.URL}roupas/`" target="_self">Roupas</a> | <a
                class="text-accent" :href="`${$scope.URL}casa/`" target="_self">Casa</a> | <a class="text-accent"
                                                                                              :href="`${$scope.URL}acessorios/`"
                                                                                              target="_self">Acessórios</a>
            </div>
        </div>
        <div v-else-if="loading && searchQuery && searchQuery.length > 0" class="text-center">
            <Spinner/>
        </div>
    </div>
</template>

<script>
    import {scrollToPosition} from "../../../common/common";
    import Spinner from "@bit/chicorei.chicomponents.indicator.spinner";

    export default {
        name: 'Search',

        components: {Spinner},

        props: {
            show: {
                type: Boolean,
                default: false
            },
            searchQuery: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                resultsCache: {},
                searchResult: null,
                loading: false,
                selectedIndex: -1
            };
        },

        created: function () {
            this.$parent.$on('input-up', this.selectPreviousSuggestion);
            this.$parent.$on('input-down', this.selectNextSuggestion);
            this.$parent.$on('input-enter', this.enterSelectedSuggestion);
        },

        watch: {
            'searchQuery'(to) {
                this.scrollTop();
                this.doSearch(to);
            }
        },

        methods: {
            scrollTop() {
                if (window.innerWidth <= 768) {
                    scrollToPosition(0, 0, 400);
                }
            },

            doSearch(query) {
                if (!query || query.length < 1) {
                    this.searchResult = null;
                    return;
                }

                query = query.toLowerCase();

                if (this.resultsCache[query]) {
                    this.searchResult = this.resultsCache[query];
                    return;
                }

                this.loading = true;
                this.searchResult = null;
                this.selectedIndex = -1;

                this.axios.http.get(this.$scope.API_LAMBDA_URL + '/products/v3/search', {
                    params: {
                        query: query,
                        onlyInStock: false,
                        listLocked: true,
                        attributes: 'search-box',
                        orderBy: 'relevancia',
                        wholesaler: !this.$scope.IS_REGULAR_CUSTOMER,
                    }
                }).then((response) => {
                    this.resultsCache[query] = response.data;
                    if (this.searchQuery.toLowerCase() === query) {
                        this.searchResult = this.resultsCache[query];
                        this.loading = false;
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            productClick(product) {
                window.location.href = product.link;
            },

            selectPreviousSuggestion() {
                if (!this.searchResult) return;
                this.selectedIndex = Math.max(-1, this.selectedIndex - 1);
            },

            selectNextSuggestion() {
                if (!this.searchResult) return;
                this.selectedIndex = Math.min(this.searchResult.hits.length - 1, this.selectedIndex + 1);
            },

            enterSelectedSuggestion(event) {
                if (!this.searchResult || this.selectedIndex < 0) return;
                if (event) event.preventDefault();
                this.productClick(this.searchResult.hits[this.selectedIndex]);
            }
        }
    }
</script>